import axios from "axios";

const featureFlagApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	timeout: 10000,
});

featureFlagApi.interceptors.request.use((config) => {
	const apiKey = process.env.REACT_APP_FEATURE_FLAG_API_KEY;
	if (apiKey) {
		config.headers["x-feature-flag-api-key"] = apiKey;
	}
	return config;
});

export const fetchFeatureFlags = async ({ refresh = true } = {}) => {
	try {
		const response = await featureFlagApi.get("/feature-flags", {
			params: {
				refresh: true,
			},
		});

		return {
			success: true,
			flags: response.data?.flags || {},
			timestamp: response.data?.timestamp,
		};
	} catch (error) {
		return {
			success: false,
			error,
		};
	}
};

export const fetchFeatureFlag = async (flagName, { refresh = false } = {}) => {
	try {
		const response = await featureFlagApi.get(`/feature-flags/${flagName}`, {
			params: { refresh },
		});

		return {
			success: true,
			flag: response.data?.details ?? response.data?.enabled ?? null,
			enabled: Boolean(response.data?.enabled),
		};
	} catch (error) {
		return {
			success: false,
			error,
		};
	}
};
